import HeaderH1 from './HeaderH1';

export default HeaderH1;